import React from "react";
import { Col, Row } from "antd";

const SubscriptionModal = ({ data }) => {
  return (
    <Row gutter={[16, 16]} justify="center" className="mt2">
      <Col span={22}>
        <Row>
          <Col span={6} className="subscription-label">
            Name:
          </Col>
          <Col span={8}>{data?.name}</Col>
        </Row>
      </Col>
      <Col span={22}>
        <Row>
          <Col span={6} className="subscription-label">
            Status:
          </Col>
          <Col span={8} className={data?.status === "ACTIVE" ? "subscription-active" : "subscription-deactive"}>{data?.status}</Col>
        </Row>
      </Col>
      <Col span={22}>
        <Row>
          <Col span={6} className="subscription-label">
            Description:
          </Col>
          <Col span={8}>{data?.description}</Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SubscriptionModal;
